import { ToolbarSlot } from '@react-pdf-viewer/default-layout';
import React from 'react';

const transformToolbar = (slot: ToolbarSlot) => ({
  ...slot,
  SwitchTheme: () => <></>,
  Open: () => <></>,
});

export default transformToolbar;
